export default __webpack_public_path__ + "static/media/location_pin_icon.a440b0dd.svg";